<form class="step-form">
  <div class="grid-container">
    <div class="grid-x grid-padding-x formfield">
      <div class="cell text-center">
        <app-advisor-image class="image-intro" path="/tec/tec-intro.svg" [altText]="'thermostatcheck.eingabe.start.alt_text' | translate"></app-advisor-image>
      </div>

      <div class="cell">
        <h2>{{ 'thermostatcheck.einstieg.headline' | translate}}</h2>
        @for (field of formConfig.getFieldsFromGroup(steps.currentStep.name); track field) {
          <div formfield [invalidIfEmpty]="false" [form]="form" [formModel]="field"  [formConfig]="formConfig" step="thermostatcheck" class="formfield "></div>
        }
      </div>

    </div>

    <div class="cell">
      <div class="callout" [innerHTML]="'thermostatcheck.eingabe.start.callout' | translate"></div>
      <div class="callout">
        <div class="button-wrapper">
          <a [href]="shortVersionButtonUrl" (click)="saveData()" [class.disabled]="!form.valid" class="button inline-arrow-right"
          target="_blank">{{ 'thermostatcheck.eingabe.start.next' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</form>
